
import { useState, useEffect } from 'react';
import axiosClient from 'api/shared/AxiosClient';

export const useAxios = (request, config = {}) => {

    const [response, setResponse] = useState(undefined);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        let isApiSubscribed = true;
        setLoading(true)
        axiosClient[request?.method](request?.url, { ...config }, request?.payload)
            .then(function (response) {
                // handle success
                if (isApiSubscribed) {
                    setResponse(response?.data);
                }

            })
            .catch(function (error) {
                // handle error
                if (isApiSubscribed) {
                    setError(error)
                }

            })
            .then(function () {
                // always executed
                if (isApiSubscribed) {
                    setLoading(false);
                }
            });

        return () => isApiSubscribed = false;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [request?.url]);

    return [response, error, loading];
};

